// Locale Google Text-to-Speech (voix Chirp 3 HD) par code de langue de l'API des pensées.
// Partagé entre le serveur (server/tts.mjs) et le navigateur (lecteur masqué pour une langue
// absente de cette liste). Codes de l'API, pas ISO : `po` = portugais, `gr` = grec,
// `am` = arménien. Google ne propose aucune voix arménienne (`am-ET` est l'amharique) : `am`
// n'est donc volontairement pas listé.
export const SPEECH_LOCALES = {
  fr: 'fr-FR',
  en: 'en-US',
  de: 'de-DE',
  es: 'es-ES',
  it: 'it-IT',
  po: 'pt-BR',
  pt: 'pt-BR',
  nl: 'nl-NL',
  ro: 'ro-RO',
  ru: 'ru-RU',
  bg: 'bg-BG',
  gr: 'el-GR',
  ar: 'ar-XA',
};

export function speechLocaleFor(lang) {
  return SPEECH_LOCALES[String(lang || '').toLowerCase()] || null;
}
